import React, { createContext, useContext, useState } from 'react';
import { cn } from '../../lib/utils';

const DialogContext = createContext();

export const Dialog = ({ open, onOpenChange, children, ...props }) => {
  const [isOpen, setIsOpen] = useState(open || false);
  const currentOpen = open !== undefined ? open : isOpen;
  const handleChange = (val) => {
    if (open === undefined) setIsOpen(val);
    if (onOpenChange) onOpenChange(val);
  };
  return (
    <DialogContext.Provider value={{ isOpen: currentOpen, setIsOpen: handleChange }}>
      {children}
    </DialogContext.Provider>
  );
};

export const DialogTrigger = ({ children, ...props }) => {
  const { setIsOpen } = useContext(DialogContext);
  return <div onClick={() => setIsOpen(true)} {...props}>{children}</div>;
};

export const DialogContent = ({ className, children, ...props }) => {
  const { isOpen, setIsOpen } = useContext(DialogContext);
  if (!isOpen) return null;
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 p-4" onClick={() => setIsOpen(false)}>
      <div className={cn(
        "relative bg-white rounded-lg shadow-xl max-w-md w-full max-h-[90vh] overflow-y-auto p-6",
        className
      )} onClick={(e) => e.stopPropagation()} {...props}>
        {children}
      </div>
    </div>
  );
};

export const DialogHeader = ({ className, ...props }) => (
  <div className={cn("flex flex-col space-y-1.5 text-center sm:text-left", className)} {...props} />
);

export const DialogTitle = ({ className, ...props }) => (
  <h2 className={cn("text-lg font-semibold leading-none tracking-tight", className)} {...props} />
);

export const DialogDescription = ({ className, ...props }) => (
  <p className={cn("text-sm text-slate-500", className)} {...props} />
);

export const DialogFooter = ({ className, ...props }) => (
  <div className={cn("flex flex-col-reverse sm:flex-row sm:justify-end sm:space-x-2 mt-4", className)} {...props} />
);
